__turbopack_context__.v({
  "className": "Zm2w8W_className",
  "variable": "Zm2w8W_variable",
});
